/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import PrivacyWarningBanner from 'bundles/common/components/PrivacyWarningBanner';
import { shouldShowToUBanner } from 'bundles/user-consent/utils/shouldShowBannerToU';

const styles = {
  privacyBanner: css`
    margin-bottom: 25px;
  `,
};

const PrivacyBannerNotConfigurable = () => {
  const shouldShowPrivacyWarningBanner = shouldShowToUBanner();

  return shouldShowPrivacyWarningBanner ? (
    <div css={styles.privacyBanner}>
      <PrivacyWarningBanner includeGrid />
    </div>
  ) : null;
};

export default PrivacyBannerNotConfigurable;
